import { FormationLocalPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const FormationLocalPersistenceProvider = createStaticContextProvider(
  FormationLocalPersistenceContext,
  lazyValue(() =>
    import("./formation-local-persistence").then(
      (module) => module.formationLocalPersistence,
    ),
  ),
);
